import {
  getAddress,
  TAddressItem,
} from '../../../../../1stlog-ui/src/components/Address/helpers'
import { useField } from '../../../../../1stlog-ui/src/components/Field'
import useFieldValue from '../../../../../1stlog-ui/src/components/Field/useFieldValue'

export type TRelevantTransportFields = {
  date: string
  provider: object
  pickupCountry: string
  pickupZip: any
  deliveryCountry: string
  deliveryZip: any
  isPickupManualDisposition: boolean
  isDeliveryManualDisposition: boolean
  pickupAddress: Partial<TAddressItem>
  deliveryAddress: Partial<TAddressItem>
}

const useRelevantTransportFields = (): TRelevantTransportFields => {
  const date = useField('date')
  const provider = useField('provider')
  const pickupCountry = useField('pickup.address.country', {
    onlyValid: true,
    ignorePrefix: true,
  })
  const pickupZip = useField('pickup.address.zip', {
    onlyValid: true,
    ignorePrefix: true,
  })
  const deliveryCountry = useField('delivery.address.country', {
    onlyValid: true,
    ignorePrefix: true,
  })
  const deliveryZip = useField('delivery.address.zip', {
    onlyValid: true,
    ignorePrefix: true,
  })
  const isPickupManualDisposition = useField('pickup.isManualDisposition', {
    ignorePrefix: true,
  })
  const isDeliveryManualDisposition = useField('delivery.isManualDisposition', {
    ignorePrefix: true,
  })

  const pickupAddress = useFieldValue<TAddressItem>('pickup.address', {
    ignorePrefix: true,
  })

  const deliveryAddress = useFieldValue<TAddressItem>('delivery.address', {
    ignorePrefix: true,
  })

  return {
    date,
    provider,
    pickupCountry,
    pickupZip,
    deliveryCountry,
    deliveryZip,
    isPickupManualDisposition,
    isDeliveryManualDisposition,
    pickupAddress: getAddress(pickupAddress),
    deliveryAddress: getAddress(deliveryAddress),
  }
}

export default useRelevantTransportFields
